import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.33398 12C3.33398 5 5.33491 3 12.3344 3C19.334 3 21.334 5 21.334 12C21.334 19 19.2571 21 12.3344 21C5.41183 21 3.33398 19 3.33398 12Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.834 9.5L9.83398 14.5M14.834 14.5L9.83398 9.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCloseBox);
export { ForwardRef as ReactComponent };
